import React from 'react';
import PropTypes from 'prop-types';
import {
  InsertDashboardPopup,
  DeleteDashboardPopup,
  SwapDashboardPopup,
  ResetDashboardSetPopup,
  SaveDashboardPopup
} from './components';

export const POPUPS_MAP = {
  INSERT_BEFORE: 'insert_before',
  INSERT_AFTER: 'insert_after',
  REPLACE: 'replace',
  SWAP: 'swap',
  DELETE: 'delete',
  RESET: 'reset',
  SAVE: 'save'
};

const renderPopupBody = ({ operation, ...rest }) => {
  switch (operation) {
    case POPUPS_MAP.INSERT_BEFORE:
    case POPUPS_MAP.INSERT_AFTER:
    case POPUPS_MAP.REPLACE:
      return <InsertDashboardPopup {...rest} />;

    case POPUPS_MAP.DELETE:
      return <DeleteDashboardPopup {...rest} />;

    case POPUPS_MAP.SWAP:
      return <SwapDashboardPopup {...rest} />;

    case POPUPS_MAP.RESET:
      return <ResetDashboardSetPopup {...rest} />;

    case POPUPS_MAP.SAVE:
      return <SaveDashboardPopup {...rest} />;

    default:
      return null;
  }
};

renderPopupBody.propTypes = {
  operation: PropTypes.string.isRequired
};

export default renderPopupBody;
